/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import CommonToast from "../../../components/_utils/CommonToast";
import SvgComponent from "../../../components/_utils/SVGComponent";
import ScheduleInternalTxnAmount from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnAmount";
import ScheduleInternalTxnConfirmSchedule from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnConfirmSchedule";
import ScheduleInternalTxnSelectAccounts from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnSelectAccounts";
import ScheduleInternalTxnSelectFrequency from "../../../components/ScheduleInternalTxn/ScheduleInternalTxnSelectFrequency";
import ScheduleTransactionStepAdditionalDetails from "../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionCreate/ScheduleTransactionStepAdditionalDetails";
import {
  beneCategories,
  resetViewAllAcc,
  uploadImages,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  scheduleInternalTxnCreate,
  scheduleInternalTxnView,
} from "../../../redux/features/scheduleInternalTxn/index";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import "./index.css";

const ScheduleInternalTransactionCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentAccountDetails = location?.state;
  const [files] = useState([]);
  const [endDate, setEndDate] = useState({});
  const [quantity, setQuantity] = useState(0);
  const [isNeft, setIsNeft] = useState(false);
  const [isRtgs, setIsRtgs] = useState(false);
  const [isImps, setIsImps] = useState(false);
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [hyperLink, setHyperLink] = useState({});

  const [activeStep, setActiveStep] = useState(0);

  const [direction, setDirection] = useState(null);
  const [refreshId, setRefreshId] = useState(true);
  const [openOwner, setOpenOwner] = useState(false);
  const [showImages] = useState("");
  const [startDateCal, setStartDateCal] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});
  const [selectedValue, setSelectedValue] = useState({});
  const [additionalData, setAdditionalData] = useState({});

  const [slideAnimation, setSlideAnimation] = useState(false);
  const [isConfidential, setIsConfidential] = useState(false);
  const [removeClassName, setRemoveClassName] = useState(true);

  const [showRupeeSymbol, setShowRupeeSymbol] = useState(false);
  const [showDatePickerCal, setShowDatePickerCal] = useState({});
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [nextButtonEnabled, setNextButtonEnabled] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);
  const [openOccurrencesModal, setOpenOccurrencesModal] = useState(false);

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: currentAccountDetails?.bank_account_holder_full_name
      ? currentAccountDetails.bank_account_holder_full_name
      : "",
    beneAccountId: currentAccountDetails?.id ? currentAccountDetails?.id : null,
    bankAccountIFSC: currentAccountDetails?.ifsc_code
      ? currentAccountDetails?.ifsc_code
      : "",
    bankAccountNo: currentAccountDetails?.bank_acc_no
      ? currentAccountDetails?.bank_acc_no
      : "",
    amount: "",
    settleType: "",
    bankLogo: currentAccountDetails?.bank_name
      ? currentAccountDetails?.bank_name
      : "",

    pan: currentAccountDetails?.pan ? currentAccountDetails?.pan : "",
    ownerPan: null,
    ownerId: null,
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerLastUpdated: null,
    ownerBankLogo: null,
    ownerBankAccountNo: null,
    ownerBankAccountName: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    destinationAccountBalance: 0,
    destinationAcountOwnerId: null,
    isDestinationOwnerActive: true,
    destinationAcountOwnerLastUpdated: null,
    scheduled_name: "",
    frequency: "",
    transaction_start_date: "",
    transaction_end_date: "",
    slot: "",
    occurrences: "",
  });

  const [similarTransaction, setSimilarTransaction] = useState(false);
  const [showSimilarModal, setShowSimilarModal] = useState(false);
  const [txnLoading, settxnLoading] = useState(false);

  const steps = [
    TEXT?.SOURCE_AND_DESTINATION_ACCOUNT,
    TEXT?.ADDITIONAL_DETAILS,
    TEXT?.TRANSFER_AMOUNT,
    TEXT?.FREQUENCY,
    TEXT?.CONFIRM_AND_CREATE,
  ];

  const animationClassS =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  const handleDateformat = (date) => {
    const formattedDate = new Date(
      new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60 * 1000,
    )
      .toISOString()
      .slice(0, 10);
    return formattedDate?.split("-")?.reverse()?.join("-");
  };

  const handleCreateBiller = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    let haveImage = txnPayLoad?.mergeCategory?.some(
      (val) => val?.data_type === "upload" && val?.value !== "Not Given",
    );

    let internalData = {
      amount: txnPayLoad?.amount,
      internal_account_id: txnPayLoad?.beneAccountId,
      owner_account_id: txnPayLoad?.ownerId,
      category: txnPayLoad?.selectedCategory?.name,
      payment_method: txnPayLoad?.settleType?.toUpperCase(),
      frequency:
        txnPayLoad?.frequency === "Half yearly"
          ? "half_yearly"
          : txnPayLoad?.frequency.toLowerCase(),
      confidential_transaction: isConfidential,
      occurrences: txnPayLoad?.occurrences,
      type_of_transactions: "Internal Transaction",
      transaction_start_date: handleDateformat(
        txnPayLoad?.transaction_start_date,
      ),
      transaction_end_date: handleDateformat(txnPayLoad?.transaction_end_date),
      slot: txnPayLoad?.slot,
      scheduled_name: txnPayLoad?.scheduled_name,
    };

    let add = GlobalConfiguration?.lengthCheckZero;

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadImages(file)),
        ),
      );

      if (responseUpload) {
        internalData.additional_data = {
          data: txnPayLoad?.mergeCategory?.map((fil) => {
            if (fil?.data_type === "toggle") {
              const { description, ...rest } = fil;

              if (fil.value === true) {
                return { ...rest, value: true };
              }

              return { ...rest };
            }

            if (
              fil?.value === "Not Given" ||
              fil?.value === "" ||
              (fil.data_type === "quantity" &&
                fil.value <= GlobalConfiguration?.lengthCheckZero)
            ) {
              const { value, ...rest } = fil;
              return rest;
            }

            if (fil?.data_type === "upload") {
              const { description, ...rest } = fil;
              return { ...rest, value: responseUpload[add++]?.payload };
            }

            return fil;
          }),
        };
      }
    } else {
      internalData.additional_data = {
        data: txnPayLoad?.mergeCategory?.map((fil) => {
          if (fil?.data_type === "toggle") {
            const { description, ...rest } = fil;

            if (fil.value === true) {
              return { ...rest, value: true };
            }

            return { ...rest };
          }
          if (
            fil?.value === "Not Given" ||
            fil?.value === "" ||
            (fil.data_type === "quantity" &&
              fil.value <= GlobalConfiguration?.lengthCheckZero)
          ) {
            const { value, ...rest } = fil;
            return rest;
          }

          return fil;
        }),
      };
    }

    dispatch(scheduleInternalTxnCreate({ services, navigate, internalData }));
    dispatch(resetViewAllAcc());
  };

  const buildDuplicateCheckPayload = () => ({
    page_no: GlobalConfiguration?.lengthCheckOne,
    page_item_count: PaginationConfiguration?.paginationSmall,
    amount: txnPayLoad?.amount,
    payment_method: txnPayLoad?.settleType?.toUpperCase(),
    internal_account_id: txnPayLoad?.beneAccountId,
    owner_account_id: txnPayLoad?.ownerId,
    confidential_transaction: isConfidential
      ? "Show only confidential"
      : !isConfidential
        ? "Hide confidential"
        : undefined,
  });

  const handleNext = async () => {
    if (activeStep === GlobalConfiguration?.lengthCheckThree) {
      setIsSubmitting(true);
      settxnLoading(true);

      const res = await dispatch(
        scheduleInternalTxnView(buildDuplicateCheckPayload()),
      );

      const hasDuplicates =
        res?.payload?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero;

      setSimilarTransaction(hasDuplicates);
      setIsSubmitting(false);

      if (hasDuplicates) {
        toast.dismiss();
        CommonToast({
          text: "Few issues found click check to view.",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      if (res.payload.status) {
        setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);
      }
      setDirection("next");
      settxnLoading(false);
      setRemoveClassName(false);
      setTimeout(
        () => setRemoveClassName(true),
        IntervalConfiguration.intervalMedium,
      );
    } else if (
      activeStep <
      steps.length - GlobalConfiguration?.lengthCheckOne
    ) {
      setActiveStep((prev) => prev + GlobalConfiguration?.lengthCheckOne);
      setDirection("next");
      setRemoveClassName(false);
      setTimeout(
        () => setRemoveClassName(true),
        IntervalConfiguration.intervalMedium,
      );
    } else {
      if (similarTransaction) {
        setShowSimilarModal(true);
      } else {
        await handleCreateBiller();
      }
    }
  };
  const handleBack = () => {
    if (activeStep === GlobalConfiguration?.lengthCheckZero) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep
          ? prevActiveStep - GlobalConfiguration?.lengthCheckOne
          : GlobalConfiguration?.lengthCheckZero,
      );
      setDirection("previous");
      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration.intervalMedium);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (activeStep === 4) {
        dispatch(scheduleInternalTxnView(buildDuplicateCheckPayload()));
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [txnPayLoad]);

  useEffect(() => {
    dispatch(beneCategories());
  }, [dispatch]);

  useEffect(() => {
    if (
      txnPayLoad.selectedCategory === null &&
      txnPayLoad.mergeCategory === null
    ) {
      setTxnPayLoad({
        ...txnPayLoad,
        selectedCategory: beneTransCategories?.categories?.filter((fil) => {
          return fil.name === "Internal";
        })[0],
        mergeCategory: beneTransCategories?.categories?.filter((fil) => {
          return fil.name === "Internal";
        })[0]?.configuration?.data,
      });
    }
  }, [beneTransCategories]);

  useEffect(() => {
    const {
      beneAccountId,
      ownerId,
      scheduled_name,
      amount,
      settleType,
      selectedCategory,
      mergeCategory,
      occurrences,
      slot,
      transaction_start_date,
      transaction_end_date,
      frequency,
    } = txnPayLoad;

    const fields = selectedCategory?.configuration?.data || [];

    const mandatoryFields = fields.filter((f) => f?.mandatory === "Y");

    const mandatoryFilled =
      mergeCategory?.filter(
        (f) =>
          f?.mandatory === "Y" &&
          (f?.data_type === "from_year_to_year"
            ? f?.value?.from && f?.value?.to
            : f?.value),
      )?.length || 0;

    const isMandatoryValid = mandatoryFields.length === mandatoryFilled;

    const hyperlinkFields =
      mergeCategory?.filter(
        (f) => f?.data_type === "hyperlink" && f?.value !== "",
      ) || [];

    const isHyperlinkValid = hyperlinkFields.every((f) =>
      isValidHttpUrl(f?.value),
    );

    const isStepZeroValid =
      !!beneAccountId && !!ownerId && scheduled_name?.length >= 5;

    const isStepOneValid =
      !mandatoryFields.length ||
      (isMandatoryValid && (hyperlinkFields.length ? isHyperlinkValid : true));

    const isAmountValid = !!amount;

    const isRtgsInvalid = isRtgs && amount <= 200000;

    const isNeftInvalid = isNeft && amount > 200000;

    const isPaymentMethodInvalid =
      (settleType === "imps" && amount > 200000) ||
      (settleType === "rtgs" && amount <= 200000) ||
      (settleType === "neft" && amount > 200000);

    const isScheduleStepInvalid =
      !occurrences ||
      !slot ||
      !transaction_start_date ||
      !transaction_end_date ||
      !frequency;

    let isStepValid = false;

    switch (activeStep) {
      case GlobalConfiguration?.lengthCheckZero:
        isStepValid = isStepZeroValid;
        break;

      case GlobalConfiguration?.lengthCheckOne:
        isStepValid = isStepOneValid;

        break;

      case GlobalConfiguration?.lengthCheckTwo:
        isStepValid =
          isAmountValid &&
          !isRtgsInvalid &&
          !isNeftInvalid &&
          !isPaymentMethodInvalid;
        break;

      case GlobalConfiguration?.lengthCheckThree:
        isStepValid = !isScheduleStepInvalid;
        break;

      default:
        isStepValid = true;
    }

    setNextButtonEnabled(isStepValid);
  }, [activeStep, txnPayLoad, isRtgs, isNeft, hyperLink]);

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const commonStepperConfig = {
    previousEnableBgColor: "var(--primary-nav-act)",
    previousDisableBgColor: "var(--text-disabled)",
    previousEnableTextColor: "var(--text-primary)",
    previousHoverOption: "white",
    nextEnableBgColor: "var(--text-primary)",
    nextDisableBgColor: "var(--text-disabled)",
    nextEnableTextColor: "var(--primary-bg)",
    nextDisableTextColor: "var(--text-primary)",
    nextHoverOption: "black",
  };

  const dataArray = steps.map((stepLabel, index) => {
    const isLastStep =
      index === steps.length - GlobalConfiguration?.lengthCheckOne;
    const isTxnLoading = isLastStep && isSubmitting;
    const nextButtonText = isLastStep
      ? similarTransaction
        ? "Check"
        : "Create"
      : "Next";

    return {
      ...commonStepperConfig,
      previousText:
        index === GlobalConfiguration?.lengthCheckZero ? "Cancel" : "Previous",
      previousIsDisabled: isTxnLoading,
      nextText: nextButtonText,
      nextLoaderNeeded: isLastStep,
      nextIsLoading: isTxnLoading,
      nextIsEnabled: isLastStep ? !isSubmitting : nextButtonEnabled,
      nextEnableBgColor: isLastStep
        ? similarTransaction
          ? "var(--emphasis)"
          : "var(--positive-act)"
        : "var(--text-primary)",
      nextDisableBgColor: isLastStep
        ? "var(--positive-act)"
        : "var(--text-disabled)",
      nextEnableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--primary-bg)",
      nextDisableTextColor: isLastStep
        ? "var(--text-primary)"
        : "var(--text-primary)",
      stepperText: stepLabel,
    };
  });

  const renderBillerForms = () => {
    switch (activeStep) {
      case 0:
        return (
          <ScheduleInternalTxnSelectAccounts
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            activeStep={activeStep}
            setNextButtonEnabled={setNextButtonEnabled}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            openOwner={openOwner}
            setOpenOwner={setOpenOwner}
            refreshId={refreshId}
            isConfidential={isConfidential}
            setIsConfidential={setIsConfidential}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            showDatePickerCal={showDatePickerCal}
            setShowDatePickerCal={setShowDatePickerCal}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            quantity={quantity}
            setQuantity={setQuantity}
            hyperLink={hyperLink}
            setHyperLink={setHyperLink}
            timeData={timeData}
            setTimeData={setTimeData}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
          />
        );

      case 1:
        return (
          <ScheduleTransactionStepAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            timeData={timeData}
            setTimeData={setTimeData}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            previewImages={previewImages}
            setPreviewImages={setPreviewImages}
            quantities={quantity}
            setQuantities={setQuantity}
          />
        );
      case 2:
        return (
          <ScheduleInternalTxnAmount
            slideAnimation={slideAnimation}
            setSlideAnimation={setSlideAnimation}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            setNextButtonEnabled={setNextButtonEnabled}
            nextButtonEnabled={nextButtonEnabled}
            activeStep={activeStep}
            setIsNeft={setIsNeft}
            setIsImps={setIsImps}
            setIsRtgs={setIsRtgs}
            isNeft={isNeft}
            isRtgs={isRtgs}
            isImps={isImps}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
            showRupeeSymbol={showRupeeSymbol}
            setShowRupeeSymbol={setShowRupeeSymbol}
          />
        );

      case 3:
        return (
          <ScheduleInternalTxnSelectFrequency
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            amountInWords={txnPayLoad.amountInWords}
            openOccurrencesModal={openOccurrencesModal}
            setOpenOccurrencesModal={setOpenOccurrencesModal}
            txnLoading={txnLoading}
          />
        );
      case 4:
        return (
          <ScheduleInternalTxnConfirmSchedule
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            amountInWords={amountInWords}
            setRefreshId={setRefreshId}
            refreshId={refreshId}
            isConfidential={isConfidential}
            files={files}
            showImages={showImages}
            setTimeData={setTimeData}
            uploadedFiles={uploadedFiles}
            previewImages={previewImages}
            showSimilarModal={showSimilarModal}
            setShowSimilarModal={setShowSimilarModal}
            onForceCreate={handleCreateBiller}
            buildDuplicateCheckPayload={buildDuplicateCheckPayload()}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="h-screen flex-col flex overflow-hidden">
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>
      {isStepper && (
        <>
          <div
            className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md fixed top-top-base z-z-index-toast shadow-box-shadow-bottom"
            onClick={() => navigate(-1)}
          >
            <SvgComponent
              url={ICONS?.ARROW_LEFT_WHITE}
              color={"var(--text-primary)"}
              height={"var(--icon-sm)"}
              width={"var(--icon-sm)"}
              alt="Arrow"
            />
            <div className="flex flex-col ml-margin-sm">
              <div className="text-text-primary text-font-md">
                {TEXT?.CREATE_SCHEDULE_TRANSACTION}
              </div>
              <div className="text-text-primary text-font-xs">
                {steps[activeStep] || ""}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="flex flex-col h-height-full items-center relative w-width-full flex-1 overflow-y-auto overflow-x-hidden">
        <div className="max-w-screen-Qlg mx-auto flex flex-col w-width-full">
          <div className="w-width-full">
            <div className="h-navbar-height Qsmd:hidden block"></div>
          </div>
          <div
            className={`w-width-full ${
              activeStep === GlobalConfiguration?.lengthCheckZero &&
              direction === "next"
                ? ""
                : removeClassName === true
                  ? ""
                  : animationClassS
            }`}
          >
            {renderBillerForms()}
          </div>
        </div>

        <div className="w-width-full Qmd:hidden flex">
          <div className="h-timeline-top w-width-full Qmd:hidden block"></div>
        </div>
      </div>
    </div>
  );
};

export default ScheduleInternalTransactionCreate;
